import { render, staticRenderFns } from "./editCard.vue?vue&type=template&id=0112ca41&scoped=true"
import script from "./editCard.vue?vue&type=script&lang=js"
export * from "./editCard.vue?vue&type=script&lang=js"
import style0 from "./editCard.vue?vue&type=style&index=0&id=0112ca41&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0112ca41",
  null
  
)

export default component.exports